(function () {
  'use strict';

  var productDataEl = document.getElementById('gymskynsProductData');
  if (!productDataEl) return;
  var product = null;
  try { product = JSON.parse(productDataEl.textContent); } catch (e) { return; }

  var mainImage = document.getElementById('productMainImage');
  var thumbRow = document.getElementById('productThumbs');
  var priceEl = document.getElementById('productPrice');
  var stockNote = document.getElementById('stockNote');
  var addBtn = document.getElementById('productAddBtn');
  var variantInput = document.getElementById('productVariantId');
  var qtyInput = document.getElementById('gymskynsQtyInput');

  var selectedOptions = [];

  function init() {
    if (!product) return;

    if (product.options) {
      product.options.forEach(function (opt, i) {
        var selected = opt.selected_value || (opt.values ? opt.values[0] : '');
        selectedOptions[i] = selected;
      });
    }

    /* thumbs */
    if (thumbRow) {
      thumbRow.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-thumb]');
        if (!thumb) return;
        thumbRow.querySelectorAll('[data-thumb]').forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
        var img = thumb.querySelector('img');
        if (img && mainImage) {
          var src = img.getAttribute('src');
          if (src) {
            /* Thumbnails request a small width (e.g. ?width=150) via Shopify's
               CDN query param — swap it for a much larger one instead of
               reusing the thumbnail's own low-res URL as the full-size
               main image (which is what was making it look blurry/stretched). */
            var newSrc = /[?&]width=\d+/.test(src)
              ? src.replace(/([?&])width=\d+/, '$1width=1200')
              : src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=1200';
            mainImage.setAttribute('src', newSrc);
            mainImage.setAttribute('srcset', '');
            mainImage.parentElement.querySelectorAll('img').forEach(function (im) {
              if (im !== mainImage) im.remove();
            });
          }
        }
      });
    }

    /* options */
    document.querySelectorAll('[data-option-index]').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var target = e.target.closest('[data-option-value], .swatch, .size-pill');
        if (!target) return;
        var val = target.getAttribute('data-option-value') || target.getAttribute('data-color-name');
        if (!val) return;
        var optIndex = parseInt(group.getAttribute('data-option-index'), 10);
        if (isNaN(optIndex)) return;

        group.querySelectorAll('.swatch, .size-pill').forEach(function (el) {
          el.classList.remove('is-selected');
        });
        target.classList.add('is-selected');

        var colorLabel = document.getElementById('selectedOption' + optIndex);
        if (colorLabel) colorLabel.textContent = val;

        selectedOptions[optIndex] = val;
        updateVariant();
      });
    });

    /* qty stepper */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty]');
      if (!btn) return;
      e.preventDefault();
      if (!qtyInput) return;
      var val = parseInt(qtyInput.value, 10) || 1;
      var dir = btn.getAttribute('data-qty');
      if (dir === 'dec' && val > 1) val--;
      if (dir === 'inc') val++;
      qtyInput.value = val;
      var qtyHidden = document.getElementById('productQuantity');
      if (qtyHidden) qtyHidden.value = val;
    });

    /* form submit - AJAX add to cart + open drawer */
    var selectedVariant = null;
    var form = document.getElementById('gymskyns-product-form');
    function setBtnState(btn, text) {
      if (!btn) return;
      btn.innerHTML = '<span class="btn-shine"></span>' + text;
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn && addBtn.disabled) return;
        var id = variantInput ? variantInput.value : null;
        if (!id && selectedVariant) id = selectedVariant.id;
        if (!id) return;
        var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
        function setLoading(btn) {
          if (!btn) return;
          btn.disabled = true;
          btn.classList.add('btn--loading');
          btn.classList.remove('btn--added');
          setBtnState(btn, 'Adding\u2026');
        }
        function clearBtnState(btn, text) {
          if (!btn) return;
          btn.classList.remove('btn--loading', 'btn--added');
          setBtnState(btn, text);
          btn.disabled = false;
        }
        if (addBtn) {
          addBtn.disabled = true;
          if (!addBtn.dataset.originalText) addBtn.dataset.originalText = 'Add to Cart';
          setLoading(addBtn);
        }
        var stickyBtn = document.getElementById('stickyAddBtn');
        if (stickyBtn) { setLoading(stickyBtn); }
        fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: id, quantity: qty })
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Server error (' + r.status + ')'); });
            return r.json();
          })
          .then(function (data) {
            if (data.status) throw new Error(data.description);
            window.GYMSKYNS_updateCartCount(data.item_count);
            window.GYMSKYNS_showCartToast((product && product.title ? product.title + ' \u2014 Added' : 'Added to cart'));
            function setAdded(btn) {
              if (!btn) return;
              btn.classList.remove('btn--loading');
              btn.classList.add('btn--added');
              setBtnState(btn, 'Added!');
            }
            setAdded(addBtn);
            if (stickyBtn) setAdded(stickyBtn);
            /* open Dawn cart drawer and re-render with updated contents */
            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              /* Use Section Rendering API to get updated cart-drawer HTML */
              fetch(window.location.pathname + '?section_id=cart-drawer')
                .then(function (r) { return r.text(); })
                .then(function (html) {
                  var parser = new DOMParser();
                  var doc = parser.parseFromString(html, 'text/html');
                  var newInner = doc.querySelector('#CartDrawer');
                  var oldInner = document.querySelector('#CartDrawer');
                  if (newInner && oldInner) oldInner.innerHTML = newInner.innerHTML;
                  /* is-empty lives on <cart-drawer> itself (outside #CartDrawer),
                     so the innerHTML swap alone leaves the drawer stuck in its
                     empty state — sync it from the freshly rendered section */
                  var newDrawer = doc.querySelector('cart-drawer');
                  if (newDrawer) cartDrawer.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));
                  /* overlay node was replaced by the swap — rebind close */
                  var overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
                  if (overlay) overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
                  if (cartDrawer.open) cartDrawer.open();
                })
                .catch(function () {
                  if (cartDrawer.open) cartDrawer.open();
                });
            } else {
              var toggle = document.getElementById('cart-icon-bubble');
              if (toggle) toggle.click();
            }
            var restoreText = (addBtn && addBtn.dataset.originalText) || 'Add to Cart';
            setTimeout(function () {
              clearBtnState(addBtn, restoreText);
              if (stickyBtn) clearBtnState(stickyBtn, restoreText);
            }, 1200);
          })
          .catch(function (err) {
            window.GYMSKYNS_showCartToast(err.message || 'Could not add to cart');
            var restoreText = (addBtn && addBtn.dataset.originalText) || 'Add to Cart';
            clearBtnState(addBtn, restoreText);
            if (stickyBtn) clearBtnState(stickyBtn, restoreText);
          });
      });
    }

    /* sticky add bar - show when main add btn scrolls out of view */
    var stickyBar = document.getElementById('stickyAddBar');
    if (stickyBar && addBtn) {
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
          });
        }, { threshold: 0, rootMargin: '0px 0px -100px 0px' });
        observer.observe(addBtn);
      }
      /* sticky button triggers main form submit */
      stickyBar.addEventListener('click', function (e) {
        var btn = e.target.closest('#stickyAddBtn');
        if (!btn || btn.disabled) return;
        var mainForm = document.getElementById('gymskyns-product-form');
        if (mainForm) mainForm.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }

    /* sync initial variant state */
    updateVariant();
  }

  function updateVariant() {
    if (!product || !product.variants) return;

    var found = null;
    product.variants.forEach(function (v) {
      var match = true;
      (product.options || []).forEach(function (opt, i) {
        var selected = selectedOptions[i] || '';
        var vOpt = v['option' + (i + 1)] || '';
        if (selected.toLowerCase().trim() !== vOpt.toLowerCase().trim()) match = false;
      });
      if (match) found = v;
    });

    selectedVariant = found || null;

    if (variantInput) {
      variantInput.value = selectedVariant ? selectedVariant.id : '';
    }

    updatePrice(selectedVariant);
    updateImage(selectedVariant);
    updateStockNote(selectedVariant);
    updateAddBtn(selectedVariant);
    updateThumbs(selectedVariant);
  }

  function updatePrice(variant) {
    if (!priceEl) return;
    if (!variant) {
      priceEl.textContent = '—';
      var stickyPrice = document.getElementById('stickyAddPrice');
      if (stickyPrice) stickyPrice.textContent = '—';
      return;
    }
    var price = Shopify.formatMoney ? Shopify.formatMoney(variant.price) : '$' + (variant.price / 100).toFixed(2);
    var compare = variant.compare_at_price && variant.compare_at_price > variant.price
      ? (Shopify.formatMoney ? Shopify.formatMoney(variant.compare_at_price) : '$' + (variant.compare_at_price / 100).toFixed(2))
      : null;

    if (compare) {
      priceEl.innerHTML = '<del>' + compare + '</del> ' + price;
    } else {
      priceEl.innerHTML = price;
    }

    var stickyPrice = document.getElementById('stickyAddPrice');
    if (stickyPrice) stickyPrice.textContent = price;

    var saleBadge = priceEl.parentElement.querySelector('.save-badge');
    if (saleBadge) {
      if (compare) {
        var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
        saleBadge.textContent = 'Save ' + pct + '%';
        saleBadge.style.display = saleBadge.tagName === 'SPAN' ? 'inline-block' : '';
      } else {
        saleBadge.style.display = 'none';
      }
    }
  }

  function updateImage(variant) {
    if (!mainImage) return;
    var imgSrc = null;
    if (variant && variant.featured_image) {
      imgSrc = variant.featured_image.src;
    } else if (product && product.images && product.images.length > 0) {
      imgSrc = product.images[0];
    }
    if (imgSrc) {
      mainImage.setAttribute('src', imgSrc.replace(/\/(\d+)x(\d+)/, '/900x'));
      mainImage.removeAttribute('srcset');
    }
    if (thumbRow && variant && variant.featured_image) {
      thumbRow.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.classList.remove('is-active');
        var thumbImg = t.querySelector('img');
        if (thumbImg) {
          var thumbSrc = thumbImg.getAttribute('src');
          if (thumbSrc && thumbSrc.indexOf(variant.featured_image.id) > -1) {
            t.classList.add('is-active');
          }
        }
      });
    }
  }

  function updateThumbs(variant) {
    if (!thumbRow || !variant) return;
    thumbRow.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.classList.remove('is-active');
      var mediaId = t.getAttribute('data-media-id');
      if (variant.featured_media && mediaId && String(mediaId) === String(variant.featured_media.id)) {
        t.classList.add('is-active');
      }
      if (!variant.featured_media && variant.featured_image) {
        var img = t.querySelector('img');
        if (img && img.getAttribute('src')) {
          if (img.getAttribute('src').indexOf('/' + variant.featured_image.id + '/') > -1) {
            t.classList.add('is-active');
          }
        }
      }
    });
  }

  function updateStockNote(variant) {
    if (!stockNote) return;
    var dot = stockNote.querySelector('.stock-dot');
    if (variant && variant.available) {
      stockNote.innerHTML = '<span class="stock-dot"></span> In stock — ready to ship in 1–2 business days';
    } else {
      stockNote.innerHTML = '<span class="stock-dot" style="background:#999;box-shadow:none;"></span> Out of stock';
    }
  }

  function updateAddBtn(variant) {
    if (!addBtn) return;
    var shine = addBtn.querySelector('.btn-shine');
    var label = addBtn.querySelector('.btn-shine ~ text') || addBtn;
    if (variant && variant.available) {
      addBtn.disabled = false;
      addBtn.innerHTML = '<span class="btn-shine"></span>Add to Cart';
    } else {
      addBtn.disabled = true;
      addBtn.innerHTML = '<span class="btn-shine"></span>Sold Out';
    }
    /* sync sticky bar button */
    var stickyBtn = document.getElementById('stickyAddBtn');
    if (stickyBtn) {
      stickyBtn.disabled = addBtn.disabled;
      stickyBtn.innerHTML = addBtn.innerHTML;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
